import React, {
  useEffect,
  useState,
  useMemo,
  Fragment,
  useRef,
  memo,
  useCallback,
} from "react";
import { encodeId, generateCalanderMonthView, getWeekDay } from "utils";
import moment from "moment";
import constants from "../../../../../../../constants";
import styles from "./../../../../Scheduler.module.scss";
import { Col, Row } from "reactstrap";
import Text from "components/Text";
import { withTranslation } from "react-i18next";
import Loader from "components/Loader";
import { findKey } from "lodash";
import { toast } from "react-toastify";
import toastHot from "react-hot-toast";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import AccountImage from "assets/images/account_circle.svg";
import HolidayImage from "assets/images/early_on.svg";
import Empty from "components/Empty";
import {
  MoreTagsFunction,
  renderOfficeNameOrEnterprise,
  setterCustomSchduler,
  setterPublishOffices,
  matchedBothPatternValues,
  matchedBothDatesValues,
} from "accountOwner/pages/AddEvent/addEvents.functions";
import InviteesPopup from "accountOwner/pages/EventDetails/components/Modals/InviteesPopup";
import {
  addAllItemsTypes,
  filterEventsBySearch,
  filteringMethodForEventShiftOthers,
  highlightClassWhenEventWillExist,
  leaveClasses,
} from "accountOwner/pages/Scheduler/scheduler.function";
import { useParams } from "react-router-dom";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import {
  updateBusySlot,
  useCreateUpdateSchedulerEventMutation,
  getEventListDetails,
  getBusySlot,
} from "repositories/scheduler-repository";
import { useQueryClient } from "react-query";
import { getOfficeDetail } from "repositories/office-repository";
import { addEditEventsConst } from "accountOwner/pages/AddEvent/addEvents.constants";
import EditOptionsModal, {
  editTypesVariables,
} from "accountOwner/pages/EditEvent/EditOptionsModal";
import { v4 as uuid4 } from "uuid";

const DEFAULT_DARK_COLOR = "#2D3245";
const OWNER_COLOR = "#8c0346";

const getOfficeColor = (user, selectedOwnerId) => {
  if (user?.id === selectedOwnerId) {
    return OWNER_COLOR;
  }

  const officeColor = user?.officeColourCodes;

  if (!officeColor) {
    return DEFAULT_DARK_COLOR;
  }

  return officeColor;
};

export const leaveScreenEnabled = ({
  isfromLeaveDetailScreen,
  isFromLeaveDetail,
  requestedMomentDate,
}) => {
  return isfromLeaveDetailScreen &&
    isFromLeaveDetail &&
    requestedMomentDate
      .clone()
      .set({ hour: 1 })
      .isBetween(
        moment(isFromLeaveDetail?.startDate).startOf("day"),
        moment(isFromLeaveDetail?.endDate).endOf("day"),
      )
    ? styles["leave-detail-color"]
    : "";
};

/** Staff pill on month cells: if both Full Name and First Name filters are on, show full name. */
const getStaffDisplayNameForViewFilters = (viewSettingFilter, user) => {
  if (!user) return "";
  const full =
    user.fullName ||
    `${user.firstName || ""} ${user.lastName || ""}`.trim();
  const first = user.firstName || "";
  if (
    Array.isArray(viewSettingFilter) &&
    viewSettingFilter.includes("staffMembers")
  ) {
    return full || first;
  }
  if (
    Array.isArray(viewSettingFilter) &&
    viewSettingFilter.includes("staffFirstName")
  ) {
    return first;
  }
  return full || first;
};

const getUsefulInfo = (item, currentUserId, t) => {
  const id = item?.id;
  let officeName = renderOfficeNameOrEnterprise(item, t);
  let title = item?.title || item?.reasonForBlock || null;
  title =
    title && title.length > constants.agendaTitleLength
      ? title.slice(0, constants.agendaTitleLength).concat(" ...")
      : title;
  const timezoneCode = item?.timezoneCode || null;
  const isAllDayEvent = item?.isAllDayEvent;
  const timeString = item?.isAllDayEvent
    ? t("scheduler.agenda.allDayEvent")
    : moment(item?.startTime).format("h:mm A") +
      " - " +
      moment(item?.endTime).format("h:mm A");
  //sepecific to Schedular events
  const createdByMe = item.createdById === currentUserId;
  const isInvite = !!item.eventEmployeeStatus;
  const status = item.eventStatus;
  const location = item?.location;
  let backgroudColorClass;
  backgroudColorClass =
    status === constants.SCHEDULERSTATUS.PENDING
      ? "color-blue"
      : createdByMe
        ? ""
        : "color-grey";
  return {
    officeName,
    title,
    timezoneCode,
    timeString,
    id,
    isAllDayEvent,
    createdByMe,
    isInvite,
    status,
    backgroudColorClass,
    location,
  };
};
const getPopupData = (item, requestedDate, t) => {
  const data = {};
  data.title = item?.title || item?.reasonForBlock || null;
  data.officeName = renderOfficeNameOrEnterprise(item, t);
  data.startTime = moment(item?.startTime).format("h:mm a");
  data.endTime = moment(item?.endTime).format("h:mm a");
  data.date = moment(requestedDate).format("MMM D, YYYY [-] ddd");
  const { text } = leaveClasses(item?.statusId);

  const { agendaType } = item;
  switch (agendaType) {
    case constants.agendaType.EVENT: {
      data.tag = t("scheduler.agenda.eventTag");
      break;
    }
    case constants.agendaType.BUSY_SLOT: {
      data.tag = t("scheduler.agenda.busyTag");
      break;
    }
    case constants.agendaType.BLOCKED: {
      data.tag = t("scheduler.agenda.busyTag");
      break;
    }
    case constants.agendaType.APPOINTMENT: {
      data.tag = t("scheduler.agenda.appointmentTag");
      data.title = t("scheduler.agenda.patient", {
        name: item.patientFullName,
      });
      data.isAppointment = true;
      const status = findKey(
        constants.appointmentStatus,
        (s) => s === item.appointmentStatus,
      );
      data.appointmentStatus = status ? t(`appointmentStatus.${status}`) : "--";
      break;
    }
    case constants.agendaType.LEAVE: {
      data.tag = t(text);
      data.title = "";
      data.isLeave = true;
      break;
    }
    default: {
      break;
    }
  }
  return data;
};

const boxBgColor = (type, item) => {
  switch (type) {
    case constants.agendaType.EVENT: {
      return "theme-green-bg";
    }
    case constants.agendaType.BUSY_SLOT:
    case constants.agendaType.BLOCKED: {
      return "light-orange-bg";
    }
    case constants.agendaType.APPOINTMENT: {
      return "light-purple-bg";
    }
    case constants.agendaType.LEAVE: {
      const { main } = leaveClasses(item?.statusId);

      return main;
    }
    default: {
      return null;
    }
  }
};

const boxBgTagColor = (type, item) => {
  switch (type) {
    case constants.agendaType.EVENT: {
      return "theme-green-bg";
    }
    case constants.agendaType.BUSY_SLOT:
    case constants.agendaType.BLOCKED: {
      return "dark-orange-bg";
    }
    case constants.agendaType.APPOINTMENT: {
      return "dark-grey-bg";
    }
    case constants.agendaType.LEAVE: {
      const { Highlighter } = leaveClasses(item?.statusId);
      return Highlighter;
    }
    default: {
      return null;
    }
  }
};
const CardPopUp = memo(
  ({
    item,
    requestedDate,
    name,
    setEventListActive,
    setActivePopLast,
    t,
    currentUserId,
  }) => {
    const { data, backgroudColor, tagBackgroundColor } = useMemo(() => {
      const colorData = getUsefulInfo(item, currentUserId, t);
      return {
        data: getPopupData(item, requestedDate, t),
        backgroudColor:
          constants.agendaType.EVENT === item.agendaType
            ? colorData.backgroudColorClass
            : boxBgColor(item.agendaType, item),
        tagBackgroundColor: boxBgTagColor(item.agendaType, item),
      };
    }, [item, requestedDate, t]);

    return (
      <div className={styles["scheduler-popup-box"]}>
        <span
          className={styles["close-icon"]}
          onClick={() => {
            setEventListActive({});
            setActivePopLast(null);
          }}
        >
          &times;
        </span>
        <div
          className={
            styles["scheduler-event-box"] + " " + styles[backgroudColor]
          }
        >
          <div
            className={styles["event-tag"] + " " + styles[tagBackgroundColor]}
          >
            {data.tag}
          </div>
          <div className={styles["event-type"]}>{data.title}</div>
          <Row className={styles.row}>
            <Col sm="6">
              <Text size="10px" marginBottom="0px" weight="400" color="#87928D">
                {constants.agendaType.APPOINTMENT === item.agendaType
                  ? t("scheduler.agenda.doctorName")
                  : t("scheduler.agenda.staffName")}
              </Text>
              <Text
                size="12px"
                marginBottom="10px"
                weight="500"
                color="#2F3245"
              >
                {name}
              </Text>
            </Col>
            <Col sm="6">
              <Text size="10px" marginBottom="0px" weight="400" color="#87928D">
                {t("accountOwner.officeName")}
              </Text>
              <Text
                size="12px"
                marginBottom="10px"
                weight="500"
                color="#2F3245"
              >
                {data.officeName}
              </Text>
            </Col>
            <Col sm="6">
              <Text size="10px" marginBottom="0px" weight="400" color="#87928D">
                {t("accountOwner.date")}
              </Text>
              <Text
                size="12px"
                marginBottom="10px"
                weight="500"
                color="#2F3245"
              >
                {data.date}
              </Text>
            </Col>
            {!data.isLeave && (
              <Col sm="6">
                <Text
                  size="10px"
                  marginBottom="0px"
                  weight="400"
                  color="#87928D"
                >
                  {data.isAppointment
                    ? t("timeOfAppointment")
                    : t("staff.startTime")}
                </Text>
                <Text
                  size="12px"
                  marginBottom="12px"
                  weight="500"
                  color="#2F3245"
                >
                  {data.startTime}
                </Text>
              </Col>
            )}
            {!data.isLeave && (
              <Col sm="6">
                <Text
                  size="10px"
                  marginBottom="0px"
                  weight="400"
                  color="#87928D"
                >
                  {data.isAppointment ? t("status") : t("staff.endTime")}
                </Text>
                <Text
                  size="12px"
                  marginBottom="12px"
                  weight="500"
                  color="#2F3245"
                >
                  {data.isAppointment ? data?.appointmentStatus : data.endTime}
                </Text>
              </Col>
            )}
          </Row>
        </div>
      </div>
    );
  },
);
const PopEventListing = memo(
  ({
    data,
    index,
    requestedDate,
    seeMore,
    isEventListActive,
    eventCardView,
    getUsefulInfo,
    setEventListActive,
    setActivePopLast,
    t,
    currentUserId,
    viewSettingFilter,
    canDragEvent,
    handleDragStart,
    handleDragEnd,
    isDragging,
    draggedEvent,
  }) => {
    if (data?.length) {
      data?.splice(0, seeMore);
    }

    return (
      <>
        {data?.map((item, childIndex) => {
          const name = getStaffDisplayNameForViewFilters(
            viewSettingFilter,
            item?.user,
          );
          const itemIndexInCell = seeMore + childIndex;
          return (
            <Fragment key={item.uniqueKey}>
              {item?.agendaType &&
                eventCardView(
                  item?.agendaType,
                  item,
                  index,
                  itemIndexInCell,
                  requestedDate,
                  name,
                  constants.PopUp.innerPopUp,
                  null,
                  {
                    canDragEvent,
                    handleDragStart,
                    handleDragEnd,
                    isDragging,
                    draggedEvent,
                  },
                  true,
                )}
            </Fragment>
          );
        })}
      </>
    );
  },
);
const Mapping = memo(
  ({
    list,
    childIndex,
    childArr,
    hideOrShow = null,
    isEventListActive,
    requestedDate,
    handleDateClick,
    holidayList,
    eventCardView,
    index,
    listed,
    maxVisibleEvents,
    cellRef,
    seeMoreDate,
    openPopUp,
    setopenPopUp,
    getUsefulInfo,
    setEventListActive,
    setActivePopLast,
    t,
    currentUserId,
    viewSettingFilter,
    canDragEvent,
    handleDragStart,
    handleDragEnd,
    isDragging,
    draggedEvent,
  }) => {
    const name = getStaffDisplayNameForViewFilters(
      viewSettingFilter,
      list?.user,
    );
    const activeInnerItem =
      isEventListActive?.type === constants.PopUp.innerPopUp
        ? listed?.find((i) => i.id === isEventListActive?.id)
        : null;
    return (
      <>
        {!hideOrShow && !childIndex && (
          <div
            className={styles["date-box"]}
            onClick={() => {
              const isPastDate = moment(requestedDate).isBefore(
                moment(),
                "day",
              );
              if (!isPastDate) {
                handleDateClick(requestedDate);
              }
            }}
            style={{
              cursor: moment(requestedDate).isBefore(moment(), "day")
                ? "not-allowed"
                : "pointer",
              opacity: moment(requestedDate).isBefore(moment(), "day")
                ? 0.6
                : 1,
            }}
          >
            {moment(requestedDate).format("DD")}
            <span className={styles["day-box"]}>
              {" "}
              ({getWeekDay(requestedDate)})
            </span>
          </div>
        )}
        {!hideOrShow && !childIndex && holidayList?.length > 0 && (
          <div className={styles.holiday_title}>
            <img
              src={HolidayImage}
              alt="holiday"
              className="account_owner_image"
            />
            <div
              className={styles.holiday_title_text + " text-break text-wrap"}
            >
              {holidayList?.[0]?.title}
            </div>
          </div>
        )}
        {list?.agendaType &&
          eventCardView(
            list?.agendaType,
            list,
            index,
            childIndex,
            requestedDate,
            name,
            constants.PopUp.outerPopUp,
            hideOrShow,
            {
              canDragEvent,

              handleDragStart,

              handleDragEnd,

              isDragging,

              draggedEvent,
            },
          )}
        {!hideOrShow && (
          <div className={styles["more-event-box"]}>
            {listed?.length > maxVisibleEvents &&
              childArr.length - 1 === childIndex && (
                <Fragment>
                  <span
                    className={"link-btn"}
                    ref={(ref) => {
                      cellRef.current.seeMore = ref;
                    }}
                    onClick={() => {
                      seeMoreDate(requestedDate);
                    }}
                  >
                    {" "}
                    {t("SeeMore")}{" "}
                  </span>
                  {openPopUp?.date &&
                  requestedDate &&
                  openPopUp?.date === requestedDate ? (
                    <div
                      className={
                        styles["monthly-event-list"] +
                        " " +
                        (holidayList?.length > 0
                          ? styles["light-red-bg"]
                          : styles["no-theme-bg"])
                      }
                      onDragOver={(e) => {
                        if (isDragging && draggedEvent) {
                          return;
                        }
                        e.preventDefault();
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                    >
                      <span
                        className={styles["close-icon-list"]}
                        onClick={() => setopenPopUp({})}
                      >
                        <img
                          src={require("assets/images/close-grey.svg").default}
                          alt="icon"
                        />
                      </span>
                      <div className={styles["day-date-box"]}>
                        <div className={styles["day-name"]}>
                          {getWeekDay(requestedDate)}
                        </div>
                        {moment(requestedDate).format("D")}
                      </div>
                      <div className={styles["event-list-ul"]}>
                        <PopEventListing
                          data={[...listed]}
                          index={index}
                          requestedDate={requestedDate}
                          seeMore={maxVisibleEvents}
                          getUsefulInfo={getUsefulInfo}
                          setEventListActive={setEventListActive}
                          setActivePopLast={setActivePopLast}
                          t={t}
                          eventCardView={eventCardView}
                          viewSettingFilter={viewSettingFilter}
                          currentUserId={currentUserId}
                          canDragEvent={canDragEvent}
                          handleDragStart={handleDragStart}
                          handleDragEnd={handleDragEnd}
                          isDragging={isDragging}
                          draggedEvent={draggedEvent}
                        />
                      </div>
                      {activeInnerItem && (
                        <CardPopUp
                          item={activeInnerItem}
                          requestedDate={requestedDate}
                          name={getStaffDisplayNameForViewFilters(
                            viewSettingFilter,
                            activeInnerItem?.user,
                          )}
                          getUsefulInfo={getUsefulInfo}
                          setEventListActive={setEventListActive}
                          setActivePopLast={setActivePopLast}
                          t={t}
                          currentUserId={currentUserId}
                        />
                      )}
                    </div>
                  ) : null}
                </Fragment>
              )}
            {isEventListActive?.index === index + childIndex &&
              isEventListActive?.date ===
                moment(requestedDate).format("DD-MM-YYYY") &&
              isEventListActive?.type === constants.PopUp.outerPopUp && (
                <CardPopUp
                  item={list}
                  requestedDate={requestedDate}
                  name={name}
                  setEventListActive={setEventListActive}
                  setActivePopLast={setActivePopLast}
                  t={t}
                  currentUserId={currentUserId}
                />
              )}
          </div>
        )}
      </>
    );
  },
);
const DateCellMapping = memo(
  ({
    handleDateClick,
    eventCardView,
    index,
    seeMoreDate,
    openPopUp,
    setopenPopUp,
    isEventListActive,
    t,
    viewSettingFilter,
    setEventListActive,
    setActivePopLast,
    isFromDashBoard,
    _item,
    searchValue,
    disabledDates,
    isFromSchedulingAssistantScreen,
    allData,
    currentDate,
    showFreeSlots,
    currentUserId,
    isfromLeaveDetailScreen,
    isFromLeaveDetail,
    handleDragOver,
    handleDrop,
    isDragging,
    draggedEvent,
    dragPreviewDate,
    setDragPreviewDate,
    canDragEvent,
    handleDragStart,
    handleDragEnd,
  }) => {
    const history = useHistory();
    const [maxVisibleEvents, setMaxVisibleEvents] = useState(2);
    const intervalIdRef = useRef(null);
    const cellRef = useRef({
      seeMore: null,
      cell: null,
    });
    const prevCellHeight = useRef(0);
    const holidayList = _item?.holidayList;

    const allItems = useMemo(() => {
      let {
        appointments,
        leaves,
        schedulerBusySlots,
        schedulerEvents,
        appointmentSlots,
      } = _item;
      return addAllItemsTypes({
        schedulerEvents,
        appointments,
        schedulerBusySlots,
        appointmentSlots,
        leaves,
      });
    }, [_item]);

    // Apply search filter here
    const listed = useMemo(
      () => filterEventsBySearch(allItems, {}, searchValue, true),
      [allItems, searchValue],
    );

    const requestedDate = _item?.requestedDate;
    const requestedMomentDate = moment(requestedDate);
    const isSelectedIfRepeatTypeHasValue = useMemo(() => {
      if (disabledDates && isFromSchedulingAssistantScreen) {
        return highlightClassWhenEventWillExist({
          cellDate: new Date(requestedDate),
          allData,
          i: index,
          key: "requestedDate",
          disabledDates,
          styles,
        });
      }
      return false;
    }, [requestedDate, disabledDates]);

    const isToday =
      requestedMomentDate.format("MMM DD, ddd") ===
      moment(currentDate).format("MMM DD, ddd");

    useEffect(() => {
      if (allItems.length < maxVisibleEvents || isFromDashBoard) {
        setMaxVisibleEvents(() => 2);
        return;
      }
      setMaxVisibleEvents(() => 2);
      prevCellHeight.current = 0;
      intervalIdRef.current = setInterval(() => {
        const cellElement = cellRef.current?.cell;
        const containerHeight = cellElement?.clientHeight;
        if (!containerHeight || !cellRef.current.seeMore) return;
        if (!prevCellHeight.current) {
          prevCellHeight.current = cellElement.clientHeight;
        }
        const childrens = cellElement.children;
        const moreBoxHeight =
          childrens[childrens.length - 2]?.offsetHeight || 0;
        const lastEventHeight =
          childrens[childrens.length - 1]?.offsetHeight || 0;
        let firstOrLast = -1;
        let allChildHeight = 0;
        for (const child of childrens) {
          firstOrLast += 1;
          // continue only for see more button element
          if (childrens.length - 2 <= firstOrLast) {
            continue;
          }
          const childHeight = child.offsetHeight;
          allChildHeight += childHeight;
        }
        if (
          containerHeight - allChildHeight - moreBoxHeight >= lastEventHeight &&
          prevCellHeight.current >
            allChildHeight + moreBoxHeight + lastEventHeight
        ) {
          setMaxVisibleEvents((prev) => prev + 1);
        } else {
          clearInterval(intervalIdRef.current);
        }
      }, 100);
      return () => {
        clearInterval(intervalIdRef.current);
      };
    }, [allItems, viewSettingFilter]);
    const leaveClassFromDetail = leaveScreenEnabled({
      isfromLeaveDetailScreen,
      isFromLeaveDetail,
      requestedMomentDate,
    });

    if (
      !allItems ||
      !allItems?.length ||
      (allItems?.length && allItems[0] && !allItems[0]?.agendaType)
    ) {
      return (
        <div
          className={`${
            styles["monthly-col"] + " " + styles["monthly-td"]
          } ${leaveClassFromDetail} ${
            isToday && showFreeSlots ? styles.free_slot_border : ""
          }${holidayList?.length > 0 ? " " + styles["light-red-bg"] : ""}`}
          onDragOver={(e) => {
            if (handleDragOver) {
              handleDragOver(e, requestedDate);
            }
          }}
          onDragLeave={(e) => {
            const relatedTarget = e.relatedTarget;
            if (!relatedTarget || !e.currentTarget.contains(relatedTarget)) {
              if (setDragPreviewDate) {
                setDragPreviewDate(null);
              }
            }
          }}
          onDrop={(e) => {
            if (handleDrop) {
              handleDrop(e, requestedDate);
            }
          }}
        >
          <div
            className={styles["date-box"]}
            onClick={() => {
              const isPastDate = requestedMomentDate.isBefore(moment(), "day");
              if (!isPastDate) {
                handleDateClick(requestedDate);
              }
            }}
            style={{
              cursor: requestedMomentDate.isBefore(moment(), "day")
                ? "not-allowed"
                : "pointer",
              opacity: requestedMomentDate.isBefore(moment(), "day") ? 0.6 : 1,
            }}
          >
            {requestedMomentDate.format("DD")}
          </div>
          {holidayList?.length > 0 && (
            <div className={styles.holiday_title}>
              <img
                src={HolidayImage}
                alt="holiday"
                className="account_owner_image"
              />
              <div
                className={styles.holiday_title_text + " text-break text-wrap"}
              >
                {holidayList?.[0]?.title}
              </div>
            </div>
          )}
          {/* Drag Preview Card for empty cells */}
          {isDragging &&
          draggedEvent?.eventItem &&
          dragPreviewDate &&
          moment(requestedDate).format("YYYY-MM-DD") === dragPreviewDate ? (
            <div
              className={`${styles["scheduler-event-box"]} ${
                styles[
                  draggedEvent.eventItem.eventStatus ===
                  constants.SCHEDULERSTATUS.PENDING
                    ? "color-blue"
                    : draggedEvent.eventItem.createdById === currentUserId
                      ? ""
                      : "color-grey"
                ]
              }`}
              style={{
                border: "2px dashed #C8E364",
                borderRadius: "6px",
                opacity: 0.6,
                pointerEvents: "none",
                marginBottom: "4px",
              }}
            >
              <div className="d-flex justify-content-between">
                <div className="d-flex gap-1">
                  {draggedEvent.eventItem.agendaType ===
                    constants.agendaType.EVENT && (
                    <div
                      className={
                        styles["event-tag"] + " " + styles["theme-green-bg"]
                      }
                      style={{ opacity: 0.6 }}
                    >
                      {draggedEvent.eventItem?.isShift
                        ? t("scheduler.agenda.shiftTag")
                        : t("scheduler.agenda.eventTag")}
                    </div>
                  )}
                  {(draggedEvent.eventItem.agendaType ===
                    constants.agendaType.BUSY_SLOT ||
                    draggedEvent.eventItem.agendaType ===
                      constants.agendaType.BLOCKED) && (
                    <div
                      className={
                        styles["event-tag"] + " " + styles["dark-orange-bg"]
                      }
                      style={{ opacity: 0.6 }}
                    >
                      {t("scheduler.agenda.busyTag")}
                    </div>
                  )}
                </div>
              </div>
              {(!viewSettingFilter.length ||
                viewSettingFilter.includes("timeString")) && (
                <div className={styles["event-date"]} style={{ opacity: 0.6 }}>
                  {draggedEvent.eventItem?.isAllDayEvent ||
                  draggedEvent.eventItem?.isAllDayBusy
                    ? t("scheduler.agenda.allDayEvent")
                    : draggedEvent.eventItem?.startTime &&
                        draggedEvent.eventItem?.endTime
                      ? moment(draggedEvent.eventItem?.startTime).format(
                          "h:mm A",
                        ) +
                        " - " +
                        moment(draggedEvent.eventItem?.endTime).format("h:mm A")
                      : ""}
                  {draggedEvent.eventItem?.timezoneCode &&
                    ` (${draggedEvent.eventItem?.timezoneCode})`}
                </div>
              )}
              {(!viewSettingFilter.length ||
                viewSettingFilter.includes("title")) && (
                <div
                  className={styles["event-user"]}
                  style={{ opacity: 0.6 }}
                  title={draggedEvent.eventItem?.title}
                >
                  {draggedEvent.eventItem?.title?.length > 20
                    ? draggedEvent.eventItem?.title.slice(0, 20).concat(" ...")
                    : draggedEvent.eventItem?.title}
                </div>
              )}
            </div>
          ) : (
            <div className={styles["empty-event"]}></div>
          )}
        </div>
      );
    }

    return (
      <div
        className={`${styles["monthly-col"]} ${
          leaveClassFromDetail
            ? leaveClassFromDetail
            : holidayList?.length > 0
              ? styles["light-red-bg"]
              : styles["no-theme-bg"]
        } ${styles["monthly-td"]} ${
          openPopUp?.date === requestedDate && styles["active-date"]
        } ${isSelectedIfRepeatTypeHasValue}`}
        ref={(ref) => {
          cellRef.current.cell = ref;
        }}
        onDragOver={(e) => {
          if (handleDragOver) {
            handleDragOver(e, requestedDate);
          }
        }}
        onDragLeave={(e) => {
          const relatedTarget = e.relatedTarget;
          if (!relatedTarget || !e.currentTarget.contains(relatedTarget)) {
            if (setDragPreviewDate) {
              setDragPreviewDate(null);
            }
          }
        }}
        onDrop={(e) => {
          if (handleDrop) {
            handleDrop(e, requestedDate);
          }
        }}
      >
        {listed?.length ? (
          <>
            {listed
              .slice(0, maxVisibleEvents)
              .map((list, childIndex, childArr) => (
                <Mapping
                  list={list}
                  key={list.uniqueKey}
                  childIndex={childIndex}
                  childArr={childArr}
                  isEventListActive={isEventListActive}
                  requestedDate={requestedDate}
                  handleDateClick={handleDateClick}
                  holidayList={holidayList}
                  eventCardView={eventCardView}
                  index={index}
                  listed={listed}
                  maxVisibleEvents={maxVisibleEvents}
                  cellRef={cellRef}
                  seeMoreDate={seeMoreDate}
                  openPopUp={openPopUp}
                  setopenPopUp={setopenPopUp}
                  setEventListActive={setEventListActive}
                  setActivePopLast={setActivePopLast}
                  t={t}
                  currentUserId={currentUserId}
                  viewSettingFilter={viewSettingFilter}
                  canDragEvent={canDragEvent}
                  handleDragStart={handleDragStart}
                  handleDragEnd={handleDragEnd}
                  isDragging={isDragging}
                  draggedEvent={draggedEvent}
                />
              ))}
            {listed.length > maxVisibleEvents &&
              [listed[maxVisibleEvents]].map((list, childIndex, childArr) => (
                <Mapping
                  list={list}
                  key={list.uniqueKey}
                  childIndex={childIndex}
                  childArr={childArr}
                  isEventListActive={isEventListActive}
                  requestedDate={requestedDate}
                  handleDateClick={handleDateClick}
                  holidayList={holidayList}
                  eventCardView={eventCardView}
                  index={index}
                  listed={listed}
                  maxVisibleEvents={maxVisibleEvents}
                  cellRef={cellRef}
                  seeMoreDate={seeMoreDate}
                  openPopUp={openPopUp}
                  setopenPopUp={setopenPopUp}
                  setEventListActive={setEventListActive}
                  setActivePopLast={setActivePopLast}
                  viewSettingFilter={viewSettingFilter}
                  t={t}
                  canDragEvent={canDragEvent}
                  handleDragStart={handleDragStart}
                  handleDragEnd={handleDragEnd}
                  isDragging={isDragging}
                  draggedEvent={draggedEvent}
                  hideOrShow={{
                    position: "fixed",
                    top: "-200px",
                  }}
                />
              ))}
          </>
        ) : (
          <div
            className={
              styles["empty-event"] +
              (holidayList?.length > 0 ? " flex-column" : "")
            }
          >
            {holidayList?.length > 0 && (
              <div className={styles.holiday_title}>
                <img
                  src={HolidayImage}
                  alt="holiday"
                  className="account_owner_image"
                />
                <div
                  className={
                    styles.holiday_title_text + " text-break text-wrap"
                  }
                >
                  {holidayList?.[0]?.title}
                </div>
              </div>
            )}
          </div>
        )}
        {/* Drag Preview Card */}
        {isDragging &&
          draggedEvent?.eventItem &&
          dragPreviewDate &&
          moment(requestedDate).format("YYYY-MM-DD") === dragPreviewDate && (
            <div
              className={`${styles["scheduler-event-box"]} ${
                styles[
                  draggedEvent.eventItem.eventStatus ===
                  constants.SCHEDULERSTATUS.PENDING
                    ? "color-blue"
                    : draggedEvent.eventItem.createdById === currentUserId
                      ? ""
                      : "color-grey"
                ]
              }`}
              style={{
                border: "2px dashed #C8E364",
                borderRadius: "6px",
                opacity: 0.6,
                pointerEvents: "none",
                marginBottom: "4px",
              }}
            >
              <div className="d-flex justify-content-between">
                <div className="d-flex gap-1">
                  {draggedEvent.eventItem.agendaType ===
                    constants.agendaType.EVENT && (
                    <div
                      className={
                        styles["event-tag"] + " " + styles["theme-green-bg"]
                      }
                      style={{ opacity: 0.6 }}
                    >
                      {draggedEvent.eventItem?.isShift
                        ? t("scheduler.agenda.shiftTag")
                        : t("scheduler.agenda.eventTag")}
                    </div>
                  )}
                  {(draggedEvent.eventItem.agendaType ===
                    constants.agendaType.BUSY_SLOT ||
                    draggedEvent.eventItem.agendaType ===
                      constants.agendaType.BLOCKED) && (
                    <div
                      className={
                        styles["event-tag"] + " " + styles["dark-orange-bg"]
                      }
                      style={{ opacity: 0.6 }}
                    >
                      {t("scheduler.agenda.busyTag")}
                    </div>
                  )}
                </div>
              </div>
              {(!viewSettingFilter.length ||
                viewSettingFilter.includes("timeString")) && (
                <div className={styles["event-date"]} style={{ opacity: 0.6 }}>
                  {draggedEvent.eventItem?.isAllDayEvent ||
                  draggedEvent.eventItem?.isAllDayBusy
                    ? t("scheduler.agenda.allDayEvent")
                    : draggedEvent.eventItem?.startTime &&
                        draggedEvent.eventItem?.endTime
                      ? moment(draggedEvent.eventItem?.startTime).format(
                          "h:mm A",
                        ) +
                        " - " +
                        moment(draggedEvent.eventItem?.endTime).format("h:mm A")
                      : ""}
                  {draggedEvent.eventItem?.timezoneCode &&
                    ` (${draggedEvent.eventItem?.timezoneCode})`}
                </div>
              )}
              {(!viewSettingFilter.length ||
                viewSettingFilter.includes("title")) && (
                <div
                  className={styles["event-user"]}
                  style={{ opacity: 0.6 }}
                  title={draggedEvent.eventItem?.title}
                >
                  {draggedEvent.eventItem?.title?.length > 20
                    ? draggedEvent.eventItem?.title.slice(0, 20).concat(" ...")
                    : draggedEvent.eventItem?.title}
                </div>
              )}
            </div>
          )}
      </div>
    );
  },
);
function MonthlyViewNew({
  t,
  currentDate,
  currentUserId,
  setDateRange,
  isLoading,
  agenda,
  error,
  viewSettingFilter,
  context = "default",
  selectedStaff,
  searchValue = "",
  isEnterpriseFilterActive = false,
  isFromDashBoard = false,
  agendaTypes,
  showFreeSlots = false,
  onDateChange,
  disabledDates,
  isfromLeaveDetailScreen,
  isFromLeaveDetail,
  canShowOfficeName,
  onAgendaUpdate,
}) {
  const {
    profile,
    isStaff,
    isOwner,
    dataAccessValues,
    effectiveOwnerId: selectedOwnerId,
    effectiveOwnerIdString,
  } = useAccountOwnerCommon();
  const canEditAndViewOthersData = useCallback(
    (officeId) => {
      if (isStaff) {
        return (
          dataAccessValues?.officeList?.some(
            (res) => res.officeId === officeId && res.isAdmin,
          ) || false
        );
      }
      return isOwner;
    },
    [isStaff, isOwner, dataAccessValues?.officeList],
  );
  const weekDays = constants.weekday;
  const { eventId: eventIdFromUrl } = useParams();
  const [monthDates, setmonthDates] = useState([]);
  const [isEventListActive, setEventListActive] = useState({});
  const [openPopUp, setopenPopUp] = useState({});
  const [activePopLast, setActivePopLast] = useState(null);
  const [hoverBusySlotKey, setHoverBusySlotKey] = useState("");

  // Drag and drop state
  const [draggedEvent, setDraggedEvent] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [dragPreviewDate, setDragPreviewDate] = useState(null);
  const [editModalConfirmation, setEditModalConfirmation] = useState(false);
  const [pendingDragUpdate, setPendingDragUpdate] = useState(null);
  const [isDragDropLoading, setIsDragDropLoading] = useState(false);
  const draggedEventRef = useRef(null);
  const createSchedulerEventMutation = useCreateUpdateSchedulerEventMutation();
  const queryClient = useQueryClient();
  const startDate = moment(currentDate)
    .startOf("month")
    .startOf("isoweek")
    .format("YYYY-MM-DD");
  const displaySettingNotApplied = !viewSettingFilter?.length;
  const isFromSchedulingAssistantScreen = useMemo(
    () => context === "scheduling-assistant",
    [context],
  );
  const [nonInvitePopup, setNonInvitePopup] = useState(false);
  const [invitePopupPosition, setInvitePopupPosition] = useState({
    top: 0,
    right: 0,
  });
  const handlePopupToggle1 = (event, setter, hoverbusykey = "") => {
    event.stopPropagation();
    setHoverBusySlotKey(hoverbusykey);
    setInvitePopupPosition({
      top: 40,
      rigth: 0,
    });
    setter((prev) => !prev);
  };
  const draggedEventDateRef = useRef(null);

  const history = useHistory();
  let tableData = null;

  useEffect(() => {
    if (error) {
      toast.error(error);
    }
  }, [error]);

  useEffect(() => {
    calanderDates(currentDate);
  }, [startDate]);

  const eventCardView = (
    type,
    item,
    index,
    childIndex,
    date,
    name,
    popup,
    hideOrShow,
    dragHandlers = {},
    extra,
  ) => {
    // Extract drag handlers from parameter or use closure
    const {
      canDragEvent: canDragEventProp,
      handleDragStart: handleDragStartProp,
      handleDragEnd: handleDragEndProp,
      isDragging: isDraggingProp,
      draggedEvent: draggedEventProp,
    } = dragHandlers;

    // Use props if provided, otherwise use closure variables
    const canDragEventFn = canDragEventProp || canDragEvent;
    const handleDragStartFn = handleDragStartProp || handleDragStart;
    const handleDragEndFn = handleDragEndProp || handleDragEnd;
    const isDraggingState =
      isDraggingProp !== undefined ? isDraggingProp : isDragging;
    const draggedEventState = draggedEventProp || draggedEvent;
    let data = getUsefulInfo(item, currentUserId, t);
    const searchKey = `${item?.id}_${date}`;
    const thisHoverKey = `${searchKey}_${index}`;
    let officeName = data?.officeName?.split(",")?.map((item) => {
      return {
        name: item,
        id: item,
      };
    });

    const colorCode = getOfficeColor(item?.user, selectedOwnerId);
    let activeTab = constants.PopUp.innerPopUp === popup;
    let colorType = boxBgColor(type, item);
    const backgroudColorClass =
      item.eventStatus === constants.SCHEDULERSTATUS.PENDING
        ? "color-blue"
        : item.createdById === currentUserId
          ? ""
          : "color-grey";

    const activePopup = () => {
      const createdByOthers =
        item?.isShift && profile?.id !== item?.createdById;

      if (
        item?.createdById === currentUserId ||
        (createdByOthers && canEditAndViewOthersData(item?.officeId))
      ) {
        const locationStateSending = {
          requestedDate: date,
          fromScreen: isFromSchedulingAssistantScreen
            ? "schedulingAssistant"
            : "staffSchedule",
          schedulingAssistantState: {
            selectedStaff,
            currentDate,
          },
          eventId: eventIdFromUrl,
        };
        history.replace({
          state: locationStateSending,
          search: window.location.search,
        });
        if (type === constants.agendaType.EVENT) {
          history.push({
            pathname: constants.routes.scheduler.eventDetails.replace(
              ":eventId",
              encodeId(item.id),
            ),
            state: locationStateSending,
            search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
          });
        } else if (type === constants.agendaType.BUSY_SLOT) {
          history.push({
            pathname: constants.routes.scheduler.busySlotDetail.replace(
              ":busySlotId",
              encodeId(item.id),
            ),
            state: locationStateSending,
            search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
          });
        }
      }
      if (!activeTab) {
        setopenPopUp({});
      }

      setActivePopLast({
        id: item?.id,
        index: childIndex,
      });

      setEventListActive({
        id: item?.id,
        index: index + childIndex,
        date: moment(date).format("DD-MM-YYYY"),
        data: data,
        type: popup,
      });
    };

    const nameFilterApplied = viewSettingFilter.some((res) =>
      ["staffMembers", "staffFirstName"].includes(res),
    );
    if (type === constants.agendaType.EVENT) {
      const createdByOthers =
        item?.isShift && profile?.id !== item?.createdById;
      // Check if can drag - use function if available, otherwise check inline
      let canDrag = false;
      if (!isFromDashBoard) {
        try {
          canDrag = canDragEventFn ? canDragEventFn(item) : false;
        } catch (e) {
          // Fallback check if canDragEvent not available yet
          const createdByMe = item.createdById === currentUserId;
          const canEditOthers = canEditAndViewOthersData(item?.officeId);

          if (item.isShift) {
            canDrag = createdByMe || (createdByOthers && canEditOthers);
          } else {
            canDrag = createdByMe;
          }
        }
      }
      const isDragged =
        isDraggingState && draggedEventState?.eventItem?.id === item.id;
      let dragStarted = false;

      const handleDragStartLocal = (e) => {
        e.stopPropagation();
        if (!canDrag) {
          e.preventDefault();
          return;
        }
        dragStarted = true;
        if (handleDragStartFn) {
          handleDragStartFn(e, item, date);
        }
      };

      const handleDragEndLocal = (e) => {
        dragStarted = false;
        if (handleDragEndFn) {
          handleDragEndFn(e);
        }
      };

      const handleClick = (e) => {
        if (dragStarted) {
          e.preventDefault();
          e.stopPropagation();
          dragStarted = false;
          return;
        }
        if (isDraggingState) {
          e.stopPropagation();
          return;
        }
        activePopup();
      };

      return (
        <div
          className={`${styles["scheduler-event-box"]} ${
            styles[backgroudColorClass]
          } ${
            activeTab &&
            activePopLast?.id === item.id &&
            activePopLast?.index === childIndex &&
            styles["active-card"]
          }`}
          style={{
            ...(hideOrShow ?? {}),
            cursor: canDrag ? "grab" : "pointer",
            opacity: isDragged ? 0.5 : 1,
            userSelect: "none",
            WebkitUserSelect: "none",
          }}
          draggable={canDrag}
          onDragStart={handleDragStartLocal}
          onDragEnd={handleDragEndLocal}
          onClick={handleClick}
        >
          <div className={styles["event-tag"] + " " + styles["theme-green-bg"]}>
            {createdByOthers
              ? t("scheduler.agenda.shiftByOthers")
              : item?.isShift
                ? t("scheduler.agenda.shiftTag")
                : t("scheduler.agenda.eventTag")}
          </div>
          {(displaySettingNotApplied ||
            viewSettingFilter.includes("timeString")) && (
            <div className={styles["event-date"]}>
              {data?.timeString}({data?.timezoneCode})
            </div>
          )}

          {canShowOfficeName &&
            (displaySettingNotApplied ||
              viewSettingFilter.includes("officeName")) && (
              <div className={styles["event-office"]}>{data?.officeName}</div>
            )}

          {displaySettingNotApplied && data?.location && (
            <div className={styles["event-office"]}>
              <img
                src={require("assets/images/pin_drop_black.svg").default}
                alt="caret"
              />
              <span className="ml-1 break_all ">{data.location}</span>
            </div>
          )}

          {(displaySettingNotApplied || viewSettingFilter.includes("title")) &&
            (item?.isShift ? (
              viewSettingFilter.includes("title") && (
                <div
                  className={
                    styles["event-user"] +
                    (isFromDashBoard ? " text-break" : "")
                  }
                >
                  {data?.title?.trim()
                    ? data.title
                    : t("scheduler.agenda.shiftTag")}
                </div>
              )
            ) : (
              <div
                className={
                  styles["event-user"] + (isFromDashBoard ? " text-break" : "")
                }
              >
                {data?.title}
              </div>
            ))}
          {name && (displaySettingNotApplied || nameFilterApplied) && (
            <div
              className={styles["event-user-container"]}
              style={{ backgroundColor: colorCode }}
            >
              <img
                src={AccountImage}
                alt="account"
                className="account_owner_image"
              />
              <p
                className={styles.account_owner_name + " text-truncate"}
                title={name}
              >
                {name}
              </p>
            </div>
          )}
        </div>
      );
    }
    const { Highlighter, text } = leaveClasses(item?.statusId);
    const isLeaveType = type === constants.agendaType.LEAVE;
    const isBusySlot =
      type === constants.agendaType.BUSY_SLOT ||
      type === constants.agendaType.BLOCKED;
    // Check if can drag - use function if available, otherwise check inline
    let canDrag = false;
    if (isBusySlot && !isFromDashBoard) {
      try {
        canDrag = canDragEventFn ? canDragEventFn(item) : false;
      } catch (e) {
        // Fallback check if canDragEvent not available yet
        const createdByMe = item.createdById === currentUserId;
        const busySlotUserId = item.user?.id;
        canDrag =
          createdByMe && busySlotUserId && busySlotUserId === currentUserId;
      }
    }
    const isDragged =
      isDraggingState && draggedEventState?.eventItem?.id === item.id;
    let dragStarted = false;

    const handleDragStartLocal = (e) => {
      e.stopPropagation();
      if (!canDrag) {
        e.preventDefault();
        return;
      }
      dragStarted = true;
      if (handleDragStartFn) {
        handleDragStartFn(e, item, date);
      }
    };

    const handleDragEndLocal = (e) => {
      dragStarted = false;
      if (handleDragEndFn) {
        handleDragEndFn(e);
      }
    };

    const handleClick = (e) => {
      if (dragStarted) {
        e.preventDefault();
        e.stopPropagation();
        dragStarted = false;
        return;
      }
      if (isDraggingState) {
        e.stopPropagation();
        return;
      }
      activePopup();
    };

    return (
      <div
        className={`${styles["scheduler-event-box"]} ${styles[colorType]} ${
          activeTab &&
          activePopLast?.id === item.id &&
          activePopLast?.index === childIndex &&
          styles["active-card"]
        }`}
        style={{
          ...(hideOrShow ?? {}),
          cursor: canDrag ? "grab" : "pointer",
          opacity: isDragged ? 0.5 : 1,
          userSelect: "none",
          WebkitUserSelect: "none",
        }}
        draggable={canDrag}
        onDragStart={handleDragStartLocal}
        onDragEnd={handleDragEndLocal}
        onClick={handleClick}
        onDragOver={(e) => {
          e.stopPropagation();
        }}
        onDrop={(e) => {
          e.stopPropagation();
          e.preventDefault();
        }}
      >
        {isLeaveType ? (
          <div className={styles["event-tag"] + " " + styles[Highlighter]}>
            {t(text)}
          </div>
        ) : type === constants.agendaType.APPOINTMENT ? (
          <div className={styles["event-tag"] + " " + styles["dark-grey-bg"]}>
            {t("scheduler.agenda.appointmentTag")}
          </div>
        ) : (
          <div className={styles["event-tag"] + " " + styles["dark-orange-bg"]}>
            {t("scheduler.agenda.busyTag")}
          </div>
        )}
        {!isLeaveType &&
          (displaySettingNotApplied ||
            viewSettingFilter.includes("timeString")) && (
            <div className={styles["event-date"]}>{data?.timeString}</div>
          )}

        {canShowOfficeName &&
          (displaySettingNotApplied ||
            viewSettingFilter.includes("officeName")) && (
            <div
              className={
                styles["event-office"] + " position-relative text-wrap"
              }
            >
              <MoreTagsFunction
                parentClass={"text-wrap text-break"}
                value={officeName || []}
                lastIndex={2}
                clickHandler={(e) =>
                  handlePopupToggle1(e, setNonInvitePopup, thisHoverKey)
                }
                mapFn={(member) => `${member?.name}`}
              />
              {hoverBusySlotKey === thisHoverKey && nonInvitePopup && (
                <InviteesPopup
                  position={invitePopupPosition}
                  handleInvitePopupToggle={(e) =>
                    handlePopupToggle1(e, setNonInvitePopup)
                  }
                  list={officeName}
                  showRoleAndOffice={false}
                  isForEvent={true}
                  isfromBusySlot={true}
                  onlyOfffice
                />
              )}
            </div>
          )}

        {displaySettingNotApplied && data?.location && (
          <div className={styles["event-office"]}>
            <img
              src={require("assets/images/pin_drop_black.svg").default}
              alt="caret"
            />
            <span className="ml-1 break_all ">{data.location}</span>
          </div>
        )}

        {(displaySettingNotApplied || viewSettingFilter.includes("title")) &&
          !item?.isShift && (
            <div
              className={
                styles["event-user"] + (isFromDashBoard ? " text-break" : "")
              }
            >
              {data?.title}
            </div>
          )}

        {(displaySettingNotApplied || viewSettingFilter.includes("title")) &&
          type === constants.agendaType.APPOINTMENT && (
            <div className={styles["event-type"]}>
              {t("scheduler.agenda.appointmentTitle")}
            </div>
          )}

        {name && (displaySettingNotApplied || nameFilterApplied) && (
          <div
            className={styles["event-user-container"]}
            style={{ backgroundColor: colorCode }}
          >
            <img
              src={AccountImage}
              alt="account"
              className="account_owner_image"
            />
            <p
              className={styles.account_owner_name + " text-truncate"}
              title={name}
            >
              {name}
            </p>
          </div>
        )}
      </div>
    );
  };

  const calanderDates = (dateCurrent) => {
    if (dateCurrent) {
      let dates = generateCalanderMonthView(dateCurrent);
      setDateRange({
        startDate: moment(dateCurrent)
          .startOf("month")
          .startOf("isoweek")
          .format("YYYY-MM-DD"),
        endDate: moment(dateCurrent).endOf("month").format("YYYY-MM-DD"),
      });
      setmonthDates([...dates]);
    }
  };

  const seeMoreDate = (requestedDate) => {
    setopenPopUp({ date: requestedDate, type: constants.PopUp.outerPopUp });
    setActivePopLast("");
    setEventListActive({});
  };

  const filterAgendaBySelectedStaff = (agenda) => {
    let filteredAgendaFiltered = agenda;

    // Apply enterprise filter and agenda types filter
    if (agendaTypes?.length || isEnterpriseFilterActive) {
      filteredAgendaFiltered = agenda?.map((item, i) => {
        const filtered = filteringMethodForEventShiftOthers(
          agendaTypes,
          item,
          currentUserId,
          isEnterpriseFilterActive,
        );
        return filtered;
      });
    }

    // Apply staff filtering for scheduling-assistant context
    if (
      isFromSchedulingAssistantScreen &&
      Array.isArray(selectedStaff) &&
      selectedStaff.length > 0
    ) {
      const selectedIds = selectedStaff
        .map((s) => s.user?.id || s.id || s.userId)
        .filter(Boolean);

      filteredAgendaFiltered = filteredAgendaFiltered?.map((dateObj, i) => {
        const filterByUser = (arr) =>
          Array.isArray(arr)
            ? arr.filter(
                (item) => item.user && selectedIds.includes(item.user.id),
              )
            : arr;

        return {
          ...dateObj,
          appointments: filterByUser(dateObj.appointments),
          leaves: filterByUser(dateObj.leaves),
          schedulerBusySlots: filterByUser(dateObj.schedulerBusySlots),
          schedulerEvents: filterByUser(dateObj.schedulerEvents),
          appointmentSlots: filterByUser(dateObj.appointmentSlots),
        };
      });
    }
    return filteredAgendaFiltered;
  };

  const handleDateClick = (clickedDate) => {
    if (isFromSchedulingAssistantScreen) {
      setEventListActive({});
      setopenPopUp({});
      setActivePopLast(null);
      setHoverBusySlotKey("");
      setNonInvitePopup(false);
    }

    if (onDateChange) {
      onDateChange(new Date(clickedDate));
    }
  };

  // Check if event/shift/busy slot can be dragged
  const canDragEvent = useCallback(
    (item) => {
      if (!item) return false;

      const createdByMe = item.createdById === currentUserId;
      const createdByOthers =
        item?.isShift && profile?.id !== item?.createdById;

      // For events (non-shifts)
      if (
        (item.agendaType === constants.agendaType.EVENT || !item.agendaType) &&
        !item.isShift
      ) {
        return createdByMe;
      }

      // For shifts
      if (item.isShift) {
        if (createdByMe) {
          return true;
        }

        if (createdByOthers && isOwner) {
          return true;
        }

        if (
          createdByOthers &&
          canEditAndViewOthersData &&
          canEditAndViewOthersData(item?.officeId)
        ) {
          return true;
        }
        return false;
      }

      // For busy slots
      if (
        item.agendaType === constants.agendaType.BUSY_SLOT ||
        item.agendaType === constants.agendaType.BLOCKED
      ) {
        const busySlotUserId = item.user?.id;
        if (!busySlotUserId) {
          return false;
        }
        const isOwnBusySlot = createdByMe && busySlotUserId === currentUserId;
        return isOwnBusySlot;
      }

      return false;
    },
    [currentUserId, profile?.id, isOwner, canEditAndViewOthersData],
  );

  // Calculate new date for monthly view (preserving time)
  const calculateNewDateForMonthly = useCallback(
    (eventItem, targetDateString) => {
      if (!eventItem || !targetDateString) {
        return null;
      }

      const newDate = moment(targetDateString).startOf("day");

      // Get original date
      let originalDate = null;
      if (eventItem.date) {
        originalDate = moment(eventItem.date).startOf("day");
      } else if (eventItem.startTime) {
        originalDate = moment(eventItem.startTime).startOf("day");
      }

      // Check if same date
      if (originalDate && newDate.isSame(originalDate, "day")) {
        return null;
      }

      // Preserve original time
      let newStartTime, newEndTime;
      if (
        eventItem.isAllDayEvent ||
        eventItem.isAllDayBusy ||
        !eventItem.startTime ||
        !eventItem.endTime
      ) {
        // All-day event
        newStartTime = newDate.startOf("day").toDate();
        newEndTime = newDate.endOf("day").toDate();
      } else {
        // Preserve time from original event
        const originalStart = moment(eventItem.startTime);
        const originalEnd = moment(eventItem.endTime);
        const originalHour = originalStart.hour();
        const originalMinute = originalStart.minute();
        const originalEndHour = originalEnd.hour();
        const originalEndMinute = originalEnd.minute();

        newStartTime = newDate
          .hour(originalHour)
          .minute(originalMinute)
          .second(0)
          .toDate();
        newEndTime = newDate
          .hour(originalEndHour)
          .minute(originalEndMinute)
          .second(0)
          .toDate();
      }

      return {
        newDate: newDate.toDate(),
        newStartTime: newStartTime,
        newEndTime: newEndTime,
        newStartTimeString: moment(newStartTime).format("YYYY-MM-DDTHH:mm"),
        newEndTimeString: moment(newEndTime).format("YYYY-MM-DDTHH:mm"),
      };
    },
    [],
  );

  // Helper to check if time changed
  const getTimeCheck = useCallback((alreadyTime, selectedTime) => {
    if (alreadyTime) {
      const selectedStartTime = moment(selectedTime);
      const alreadySelectedStartTime = moment(alreadyTime);
      if (
        selectedStartTime.hour() !== alreadySelectedStartTime.hour() ||
        selectedStartTime.minute() !== alreadySelectedStartTime.minute()
      ) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  }, []);

  // Internal function to perform the actual event update
  const performEventUpdate = useCallback(
    async (eventData, newDateTime, editType, originalRequestedDate = null) => {
      if (!newDateTime || !eventData) {
        toastHot.error(t("scheduler.invalidEventData"));
        return;
      }

      const requestedDateForCheck = originalRequestedDate
        ? originalRequestedDate
        : eventData.requestedDate
          ? moment(eventData.requestedDate).format("YYYY-MM-DD")
          : eventData.startTime
            ? moment(eventData.startTime).format("YYYY-MM-DD")
            : moment(eventData.date || newDateTime.newDate).format(
                "YYYY-MM-DD",
              );

      const dateChangedResult = matchedBothDatesValues({
        eventDetail: eventData,
        repeatedEndDate: eventData.repeatedEndDate
          ? moment(eventData.repeatedEndDate).toDate()
          : moment().add(3, "month").toDate(),
        requestedDate: requestedDateForCheck,
        eventDate: newDateTime.newDate,
      });

      const startTimeChanged = getTimeCheck(
        eventData.startTime,
        newDateTime.newStartTimeString,
      );
      const endTimeChanged = getTimeCheck(
        eventData.endTime,
        newDateTime.newEndTimeString,
      );

      const originalRequestedDateForParams = originalRequestedDate
        ? moment(originalRequestedDate).format("YYYY-MM-DDTHH:mm")
        : eventData.requestedDate
          ? moment(eventData.requestedDate).format("YYYY-MM-DDTHH:mm")
          : eventData.startTime
            ? moment(eventData.startTime).format("YYYY-MM-DDTHH:mm")
            : moment(newDateTime.newDate).format("YYYY-MM-DDTHH:mm");

      const requestedDateForDateCalc = originalRequestedDate
        ? moment(originalRequestedDate).toDate()
        : eventData.requestedDate
          ? moment(eventData.requestedDate).toDate()
          : eventData.startTime
            ? moment(eventData.startTime).toDate()
            : null;

      const eventDate = moment(newDateTime.newDate).toDate();

      const originalDateForComparison = requestedDateForDateCalc
        ? moment(requestedDateForDateCalc).startOf("day")
        : eventData.startTime
          ? moment(eventData.startTime).startOf("day")
          : eventData.date
            ? moment(eventData.date).startOf("day")
            : null;

      const newDateForComparison = moment(eventDate).startOf("day");
      const dateActuallyChanged = originalDateForComparison
        ? !originalDateForComparison.isSame(newDateForComparison, "day")
        : dateChangedResult.startDateChanged;

      const finalIsEventDateChange =
        (editType === editTypesVariables.thisAndFutureEvent ||
          editType === editTypesVariables.allEvent) &&
        !dateActuallyChanged
          ? false
          : dateActuallyChanged;

      const params = {
        SchedulerEventId: eventData.id,
        OwnerId: selectedOwnerId || profile?.id,
        Title: eventData.title,
        Date: moment(
          requestedDateForDateCalc &&
            moment(requestedDateForDateCalc)
              .startOf("day")
              .isSame(moment(eventDate).startOf("day"))
            ? eventData?.date
            : eventDate,
        ).format("YYYY-MM-DDTHH:mm"),
        StartTime: newDateTime.newStartTimeString,
        EndTime: newDateTime.newEndTimeString,
        IsAllDayEvent: eventData.isAllDayEvent || false,
        RepeatedType: eventData.repeatedType || 1,
        RepeatedDay: moment(newDateTime.newDate).isoWeekday(),
        RepeatedEndDate:
          eventData.repeatedType > 1 && eventData.repeatedEndDate
            ? moment(eventData.repeatedEndDate).format("YYYY-MM-DD")
            : null,
        Location: eventData.location || "",
        BlockForPatient: eventData.blockForPatient || false,
        Note: eventData.note || "",
        PublishAsEvent: eventData.publishAsEvent || false,
        eventEmployees: Array.isArray(eventData.eventEmployees)
          ? eventData.eventEmployees
          : [],
        EventRoles: Array.isArray(eventData.eventRoles)
          ? eventData.eventRoles
          : [],
        EventTags: Array.isArray(eventData.eventTags)
          ? eventData.eventTags
          : [],
        CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
        ReminderBeforeInMins: eventData.reminderBeforeInMins || 0,
        isDraft: eventData.isDraft || false,
        requestedDate: originalRequestedDateForParams,
        timezoneCode: eventData.timezoneCode || moment.tz.guess(),
        EditType: editType || editTypesVariables.allEvent,
        UpdateFlags: {
          isTitleEdit: false,
          isStartTimeEdit: startTimeChanged,
          isEndTimeEdit: endTimeChanged,
          isAllDayEventEdit: false,
          isNoteEdit: false,
          isLocationEdit: false,
          isReminderBeforeInMinsEdit: false,
          isEnterpriseEdit: false,
          isOfficeIdEdit: false,
          EmployeeIds: [],
          RoleIds: [],
          IsRepeatTypeChange: false,
          IsEventDateChange: finalIsEventDateChange,
          IsRepeatedEndDateChange: dateChangedResult.endDateChanged,
          IsBlockForPatientChange: false,
          tagsIds: false,
        },
      };

      if (eventData.isShift) {
        params.Title = eventData.title || "";
        delete params.Location;
        delete params.Note;
        if (
          Array.isArray(eventData.eventEmployees) &&
          eventData.eventEmployees.length > 0 &&
          eventData.eventEmployees[0]
        ) {
          params.officeId = eventData.eventEmployees[0].officeId || null;
        }
      } else {
        params.IsAutoApprove = eventData.isAutoApprove || false;
      }

      try {
        setterCustomSchduler({
          params,
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||
            [],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||
            [],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });
      } catch (error) {
        console.warn("Error in setterCustomSchduler:", error);
      }

      try {
        const preferredOption = {
          dropdown: eventData.publishAsEvent
            ? [{ id: "allowInvitees" }]
            : eventData.isDraft
              ? [{ id: "saveDraft" }]
              : [{ id: "inviteesOnly" }],
          otherOptions: [],
        };
        setterPublishOffices({
          preferredOption,
          userIds: Array.isArray(eventData.eventEmployees)
            ? eventData.eventEmployees
            : [],
          publishAsEvent: eventData.publishAsEvent
            ? "allowInvitees"
            : eventData.isDraft
              ? "saveDraft"
              : "inviteesOnly",
          nonInviteesPublish: eventData.publishedType || "allOffices",
          params,
          officeIdForNonInvitee: Array.isArray(
            eventData.schedulerEventPublishedOffices,
          )
            ? eventData.schedulerEventPublishedOffices.filter(
                (office) => office && office.id,
              )
            : [],
          edit: true,
          isDraft: eventData.isDraft || false,
        });
      } catch (error) {
        console.warn("Error in setterPublishOffices:", error);
      }

      await createSchedulerEventMutation.mutateAsync(params);

      // Refresh the event list - invalidate and refetch
      queryClient.invalidateQueries(["office_agenda_Monthly"]);

      // Trigger parent component refetch if callback provided
      if (onAgendaUpdate) {
        try {
          await onAgendaUpdate();
        } catch (error) {
          console.error("Error refreshing agenda:", error);
        }
      }

      toastHot.success(t("staff.eventUpdated"));
    },
    [
      selectedOwnerId,
      profile?.id,
      createSchedulerEventMutation,
      t,
      getTimeCheck,
      queryClient,
    ],
  );

  // Update event/shift via API (with EditEvent-style checks and modal)
  const updateEventAfterDrag = useCallback(
    async (eventItem, newDateTime, editType = null) => {
      if (!newDateTime || !eventItem || !eventItem.id) {
        toastHot.error(t("scheduler.invalidEventData"));
        return;
      }

      try {
        const originalRequestedDate = draggedEventDateRef.current
          ? draggedEventDateRef.current.format("YYYY-MM-DD")
          : moment(
              draggedEventRef.current?.date ||
                eventItem.startTime ||
                eventItem.date ||
                newDateTime.newDate,
            ).format("YYYY-MM-DD");
        const eventDetails = await getEventListDetails(
          eventItem.id,
          originalRequestedDate,
        );
        const eventData = eventDetails?.data;

        if (!eventData) {
          toastHot.error(t("scheduler.eventNotFound"));
          return;
        }

        const dateChangedResult = matchedBothDatesValues({
          eventDetail: eventData,
          repeatedEndDate: eventData.repeatedEndDate
            ? moment(eventData.repeatedEndDate).toDate()
            : moment().add(3, "month").toDate(),
          requestedDate: originalRequestedDate,
          eventDate: newDateTime.newDate,
        });

        const repeatedOptionChanged = matchedBothPatternValues({
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||
            [],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||
            [],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });

        const anyChangedForDate = repeatedOptionChanged;

        const startTimeChanged = getTimeCheck(
          eventData.startTime,
          newDateTime.newStartTimeString,
        );
        const endTimeChanged = getTimeCheck(
          eventData.endTime,
          newDateTime.newEndTimeString,
        );

        const hasChanges =
          dateChangedResult.startDateChanged ||
          dateChangedResult.endDateChanged ||
          startTimeChanged ||
          endTimeChanged;

        const neverCheck =
          eventData.repeatedType ===
          addEditEventsConst.repeatedOptionsValues.never;
        if (!neverCheck && eventData.repeatedEndDate) {
          const newDateStr = moment(newDateTime.newDate).format("YYYY-MM-DD");
          const repeatedEndDateStr = moment(eventData.repeatedEndDate).format(
            "YYYY-MM-DD",
          );
          if (
            !moment(newDateStr).isBefore(repeatedEndDateStr) &&
            newDateStr !== repeatedEndDateStr
          ) {
            toastHot.error(t("form.errors.endGreater"));
            return;
          }
        }

        const isNotDrafted = !eventData.isDraft;

        if (!neverCheck && !editType && hasChanges && isNotDrafted) {
          setPendingDragUpdate({
            eventData,
            newDateTime,
            anyChangedForDate,
            originalRequestedDate,
          });
          setEditModalConfirmation(true);
          return;
        }

        let finalEditType = editType;
        if (!finalEditType) {
          if (neverCheck) {
            finalEditType = editTypesVariables.allEvent;
          } else {
            finalEditType = editTypesVariables.allEvent;
          }
        }

        await performEventUpdate(
          eventData,
          newDateTime,
          finalEditType,
          originalRequestedDate,
        );
      } catch (error) {
        toastHot.error(error.message || t("scheduler.updateFailed"));
        throw error;
      }
    },
    [t, getTimeCheck, performEventUpdate],
  );

  // Internal function to perform the actual busy slot update
  const performBusySlotUpdate = useCallback(
    async (
      busySlotData,
      newDateTime,
      editType,
      officeDetails,
      officeIds,
      busySlotEmployeeView,
      isAllDayBusy,
      repeatedType,
      repeatedEndDate,
      originalRequestedDate,
      UpdateFlags,
    ) => {
      if (!newDateTime || !busySlotData) {
        toastHot.error(t("scheduler.invalidEventData"));
        return;
      }

      const eventDateMoment = moment(newDateTime.newDate);
      const startTime = moment(newDateTime.newStartTime);
      const endTime = moment(newDateTime.newEndTime);

      const requestedDateForDateCalc = originalRequestedDate
        ? moment(originalRequestedDate).toDate()
        : busySlotData.requestedDate
          ? moment(busySlotData.requestedDate).toDate()
          : busySlotData.startTime
            ? moment(busySlotData.startTime).toDate()
            : null;

      const eventDate = eventDateMoment.toDate();

      const formatBusySlotTime = (timeValue, startOrEnd) => {
        if (isAllDayBusy) {
          return moment(eventDateMoment)
            [startOrEnd]("day")
            .format("YYYY-MM-DDTHH:mm");
        }
        if (!timeValue) {
          return null;
        }
        return (
          moment(eventDateMoment).format("YYYY-MM-DDT") +
          moment(timeValue).format("HH:mm")
        );
      };

      const params = {
        OwnerId: officeDetails.ownerId,
        OfficeIds: officeIds,
        Title: busySlotData.title || "",
        Date: moment(
          requestedDateForDateCalc &&
            moment(requestedDateForDateCalc)
              .startOf("day")
              .isSame(moment(eventDate).startOf("day"))
            ? busySlotData?.date
            : eventDate,
        ).format("YYYY-MM-DDTHH:mm"),
        StartTime: formatBusySlotTime(startTime, "startOf"),
        EndTime: formatBusySlotTime(endTime, "endOf"),
        repeatedType: +repeatedType,
        CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
        repeatedDay: +repeatedType === 1 ? null : eventDateMoment.isoWeekday(),
        RepeatedEndDate:
          +repeatedType === 1
            ? null
            : moment(repeatedEndDate).format("YYYY-MM-DD"),
        Location: busySlotData.location || "",
        Description: busySlotData.description || "",
        IsNotifyEmployee: busySlotData.isNotifyEmployee || false,
        BusySlotEmployeeView: busySlotEmployeeView,
        IsAllDayBusy: isAllDayBusy,
      };

      try {
        setterCustomSchduler({
          params,
          repeatedType: repeatedType,
          repeatedTypeFrequency: busySlotData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: busySlotData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            busySlotData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedSlotDate:
            busySlotData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||
            [],
          selectedWeek: busySlotData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            busySlotData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) || [],
          selectedMonths:
            busySlotData.customRepeatPattern?.monthsOfYear?.map(
              (m) => m?.month,
            ) || [],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: busySlotData,
        });
      } catch (error) {
        console.warn("Error in setterCustomSchduler:", error);
      }

      params.UpdateFlags = UpdateFlags;
      params.EditType = editType || 3;
      params.SchedulerBusySlotId = busySlotData.id;
      params.RequestedDate = originalRequestedDate;
      delete params.isRepeated;

      await updateBusySlot(params);

      await queryClient.invalidateQueries(["office_agenda_Monthly"]);

      // Trigger parent component refresh if callback provided
      if (onAgendaUpdate) {
        try {
          await onAgendaUpdate();
        } catch (error) {
          console.error("Error refreshing agenda:", error);
        }
      }

      toastHot.success(t("scheduler.busySlotUpdated"));
    },
    [t, queryClient],
  );

  // Update busy slot via API
  const updateBusySlotAfterDrag = useCallback(
    async (eventItem, newDateTime, editType = null) => {
      if (!newDateTime || !eventItem || !eventItem.id) {
        toastHot.error(t("scheduler.invalidEventData"));
        return;
      }

      try {
        const originalRequestedDate = draggedEventDateRef.current
          ? draggedEventDateRef.current.format("YYYY-MM-DD")
          : moment(
              draggedEventRef.current?.date ||
                eventItem.startTime ||
                eventItem.date ||
                newDateTime.newDate,
            ).format("YYYY-MM-DD");

        let busySlotDetails = null;
        try {
          busySlotDetails = await getBusySlot({
            queryKey: [
              "busy-slot-details",
              eventItem.id,
              originalRequestedDate,
            ],
          });
        } catch (error) {
          toastHot.error(error.message || t("scheduler.updateFailed"));
          return;
        }

        const busySlotData = busySlotDetails?.data;

        if (!busySlotData) {
          toastHot.error(t("scheduler.eventNotFound"));
          return;
        }

        const officeId = busySlotData.officeId || eventItem.officeId;
        if (!officeId) {
          toastHot.error(t("scheduler.officeIdRequired"));
          return;
        }

        let officeDetails = null;
        try {
          officeDetails = await getOfficeDetail(officeId);
        } catch (error) {
          toastHot.error(
            error.message || t("scheduler.failedToFetchOfficeDetails"),
          );
          return;
        }

        if (!officeDetails) {
          toastHot.error(t("scheduler.officeDetailsNotFound"));
          return;
        }

        const isAllDayBusy =
          eventItem.isAllDayBusy ||
          eventItem.isAllDayEvent ||
          !eventItem.startTime ||
          !eventItem.endTime;

        // Build OfficeIds array - if schedulerBusySlotOffice exists, use it, otherwise create new
        let officeIds = [];
        if (
          busySlotData.schedulerBusySlotOffice &&
          Array.isArray(busySlotData.schedulerBusySlotOffice)
        ) {
          officeIds = busySlotData.schedulerBusySlotOffice.map((ele) => ({
            id: ele.externalId || ele.id || 0,
            SchedulerBusySlotId: busySlotData.id,
            OfficeId: ele.officeId,
            IsDeleted: false,
          }));
        } else {
          // If no schedulerBusySlotOffice, create from officeId
          officeIds = [
            {
              id: 0,
              SchedulerBusySlotId: busySlotData.id,
              OfficeId: officeId,
              IsDeleted: false,
            },
          ];
        }

        // Build BusySlotEmployeeView
        const busySlotEmployeeView = (
          busySlotData.busySlotNotifiedUsers ||
          eventItem.busySlotNotifiedUsers ||
          []
        ).map((item) => ({
          userid: item.userId,
          OfficeId: item.officeId || officeId,
        }));

        const dateChangedResult = matchedBothDatesValues({
          eventDetail: busySlotData,
          repeatedEndDate: busySlotData.repeatedEndDate
            ? moment(busySlotData.repeatedEndDate).toDate()
            : moment().add(3, "month").toDate(),
          requestedDate: originalRequestedDate,
          eventDate: newDateTime.newDate,
        });

        const startTimeChanged = getTimeCheck(
          busySlotData.startTime,
          newDateTime.newStartTimeString,
        );
        const endTimeChanged = getTimeCheck(
          busySlotData.endTime,
          newDateTime.newEndTimeString,
        );

        const UpdateFlags = {
          isTitleEdit: false,
          isStartTimeEdit: startTimeChanged,
          isEndTimeEdit: endTimeChanged,
          isAllDayBusyEdit: false,
          isLocationEdit: false,
          isDescriptionEdit: false,
          isNotifyEmployeeEdit: false,
          IsBusySlotDateChange: dateChangedResult.startDateChanged,
          IsRepeatedEndDateChange: dateChangedResult.endDateChanged,
        };

        const neverCheck =
          busySlotData.repeatedType ===
          addEditEventsConst.repeatedOptionsValues.never;

        if (!neverCheck && !editType) {
          setPendingDragUpdate({
            eventData: busySlotData,
            newDateTime,
            anyChangedForDate: false,
            originalRequestedDate,
            isBusySlot: true,
            officeDetails,
            officeIds,
            busySlotEmployeeView,
            isAllDayBusy,
            repeatedType: busySlotData.repeatedType,
            repeatedEndDate: busySlotData.repeatedEndDate,
            UpdateFlags,
          });
          setEditModalConfirmation(true);
          return;
        }

        let finalEditType = editType;
        if (!finalEditType) {
          finalEditType = editTypesVariables.allEvent;
        }

        await performBusySlotUpdate(
          busySlotData,
          newDateTime,
          finalEditType,
          officeDetails,
          officeIds,
          busySlotEmployeeView,
          isAllDayBusy,
          busySlotData.repeatedType,
          busySlotData.repeatedEndDate,
          originalRequestedDate,
          UpdateFlags,
        );
      } catch (error) {
        toastHot.error(error.message || t("scheduler.updateFailed"));
        throw error;
      }
    },
    [t, getTimeCheck, performBusySlotUpdate],
  );

  // Handle drag start
  const handleDragStart = useCallback(
    (e, eventItem, date) => {
      if (!canDragEvent(eventItem)) {
        e.preventDefault();
        return;
      }

      let originalDate = null;
      if (date) {
        originalDate = moment(date).startOf("day");
      } else if (eventItem.date) {
        originalDate = moment(eventItem.date).startOf("day");
      } else if (eventItem.startTime) {
        originalDate = moment(eventItem.startTime).startOf("day");
      }

      const dragData = {
        eventItem,
        originalDate: originalDate ? originalDate.format("YYYY-MM-DD") : null,
        date,
      };
      draggedEventDateRef.current = moment(date).startOf("day");
      setDraggedEvent(dragData);
      draggedEventRef.current = dragData;
      setIsDragging(true);

      const rect = e.currentTarget.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      const dragImage = e.currentTarget.cloneNode(true);
      dragImage.style.opacity = "0";
      dragImage.style.position = "absolute";
      dragImage.style.top = "-1000px";
      document.body.appendChild(dragImage);
      e.dataTransfer.setDragImage(dragImage, offsetX, offsetY);
      setTimeout(() => document.body.removeChild(dragImage), 0);
    },
    [canDragEvent],
  );

  // Handle drag over
  const handleDragOver = useCallback(
    (e, date) => {
      if (!draggedEvent) {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      e.dataTransfer.dropEffect = "move";

      if (date) {
        let formattedDate = date;
        if (date instanceof Date) {
          formattedDate = moment(date).format("YYYY-MM-DD");
        } else if (date && typeof date.format === "function") {
          formattedDate = date.format("YYYY-MM-DD");
        } else if (typeof date === "string") {
          const parsed = moment(date);
          formattedDate = parsed.isValid() ? parsed.format("YYYY-MM-DD") : date;
        }
        // Only update state if the date actually changed to prevent unnecessary rerenders
        setDragPreviewDate((prevDate) => {
          if (prevDate === formattedDate) {
            return prevDate;
          }
          return formattedDate;
        });
      }
    },
    [draggedEvent],
  );

  // Handle drop
  const handleDrop = useCallback(
    async (e, targetDateString) => {
      e.preventDefault();
      e.stopPropagation();
      const currentDraggedEvent = draggedEventRef.current || draggedEvent;

      if (!currentDraggedEvent || !currentDraggedEvent.eventItem) {
        setIsDragging(false);
        setDraggedEvent(null);
        draggedEventRef.current = null;
        return;
      }

      const { eventItem } = currentDraggedEvent;
      if (!eventItem || !eventItem.id) {
        toastHot.error(t("scheduler.invalidEventData"));
        setIsDragging(false);
        setDraggedEvent(null);
        return;
      }

      let formattedDate = targetDateString;
      if (targetDateString instanceof Date) {
        formattedDate = moment(targetDateString).format("YYYY-MM-DD");
      } else if (
        targetDateString &&
        typeof targetDateString.format === "function"
      ) {
        formattedDate = targetDateString.format("YYYY-MM-DD");
      } else if (typeof targetDateString === "string") {
        const parsed = moment(targetDateString);
        if (parsed.isValid()) {
          formattedDate = parsed.format("YYYY-MM-DD");
        } else {
          console.error("Invalid date string:", targetDateString);
        }
      } else {
        const parsed = moment(targetDateString);
        if (parsed.isValid()) {
          formattedDate = parsed.format("YYYY-MM-DD");
        } else {
          console.error("Invalid date format:", targetDateString);
        }
      }
      if (
        moment(formattedDate).isSame(
          moment(currentDraggedEvent?.date).startOf("day"),
        )
      ) {
        setIsDragging(false);
        setDraggedEvent(null);
        draggedEventRef.current = null;
        setDragPreviewDate(null);
        return;
      }
      const newDateTime = calculateNewDateForMonthly(eventItem, formattedDate);

      if (!newDateTime) {
        setIsDragging(false);
        setDraggedEvent(null);
        return;
      }

      setIsDragDropLoading(true);
      try {
        const isBusySlot =
          eventItem.agendaType === constants.agendaType.BUSY_SLOT ||
          eventItem.agendaType === constants.agendaType.BLOCKED;

        if (isBusySlot) {
          await updateBusySlotAfterDrag(eventItem, newDateTime);
        } else {
          await updateEventAfterDrag(eventItem, newDateTime);
        }

        setopenPopUp({});
        setEventListActive({});
        setActivePopLast(null);
      } catch (error) {
        console.error("Error in drag update:", error);
      } finally {
        setIsDragDropLoading(false);
        setIsDragging(false);
        setDraggedEvent(null);
        draggedEventRef.current = null;
        setDragPreviewDate(null);
      }
    },
    [
      draggedEvent,
      calculateNewDateForMonthly,
      updateEventAfterDrag,
      updateBusySlotAfterDrag,
      t,
    ],
  );

  // Handle drag end
  const handleDragEnd = useCallback(() => {
    if (!isDragDropLoading) {
      setIsDragging(false);
      setDraggedEvent(null);
      draggedEventRef.current = null;
      setDragPreviewDate(null);
    }
  }, [isDragDropLoading]);
  let filteredAgenda = filterAgendaBySelectedStaff(agenda);

  if (filteredAgenda?.length) {
    tableData = filteredAgenda.map((_item, index, allData) => {
      if (!_item?.requestedDate && monthDates?.length) {
        _item.requestedDate = monthDates[index].date;
      }
      return (
        <DateCellMapping
          key={_item.uniqueKey}
          handleDateClick={handleDateClick}
          eventCardView={eventCardView}
          index={index}
          seeMoreDate={seeMoreDate}
          openPopUp={openPopUp}
          setopenPopUp={setopenPopUp}
          isEventListActive={isEventListActive}
          viewSettingFilter={viewSettingFilter}
          t={t}
          _item={_item}
          getUsefulInfo={getUsefulInfo}
          setEventListActive={setEventListActive}
          setActivePopLast={setActivePopLast}
          isFromDashBoard={isFromDashBoard}
          searchValue={searchValue}
          disabledDates={disabledDates}
          context={context}
          allData={allData}
          currentDate={currentDate}
          currentUserId={currentUserId}
          showFreeSlots={showFreeSlots}
          isFromSchedulingAssistantScreen={isFromSchedulingAssistantScreen}
          isfromLeaveDetailScreen={isfromLeaveDetailScreen}
          isFromLeaveDetail={isFromLeaveDetail}
          handleDragOver={handleDragOver}
          handleDrop={handleDrop}
          isDragging={isDragging}
          draggedEvent={draggedEvent}
          dragPreviewDate={dragPreviewDate}
          setDragPreviewDate={setDragPreviewDate}
          canDragEvent={canDragEvent}
          handleDragStart={handleDragStart}
          handleDragEnd={handleDragEnd}
        />
      );
    });
  }

  return (
    <div
      className={`${styles["montly-calendar-wrapper"]} ${
        filteredAgenda?.length === 0 ? "center_empty" : ""
      } ${isFromDashBoard ? styles["monthly-schedular-dashboard-box"] : styles["monthly-schedular-box"]}`}
    >
      {(isLoading || isDragDropLoading) && <Loader />}
      <div className={styles["monthly-tr"]}>
        {weekDays?.map((item, index) => (
          <div
            key={item}
            className={
              styles["monthly-th"] +
              " " +
              styles["monthly-col"] +
              " border-right-none"
            }
          >
            {item.slice(0, 3)}
          </div>
        ))}
      </div>
      {filteredAgenda?.length > 0 ? (
        <div
          className={styles["monthly-tr"]}
          style={
            isFromDashBoard ? { maxHeight: "390px" } : { maxHeight: "800px" }
          }
        >
          {tableData}
        </div>
      ) : (
        <div className="div_center h-100">
          <Empty Message={t("scheduler.noEventsFound")} />
        </div>
      )}
      {editModalConfirmation && pendingDragUpdate && (
        <EditOptionsModal
          isOpen={editModalConfirmation}
          closeStepOneModal={setEditModalConfirmation}
          loader={isDragDropLoading}
          eventKey={
            pendingDragUpdate.isBusySlot
              ? {
                  eventOrShift: t("accountOwner.busySlot").toLowerCase(),
                }
              : {
                  eventOrShift: t(
                    `accountOwner.${
                      pendingDragUpdate.eventData?.isShift ? "shift" : "event"
                    }Tab`,
                  ).toLowerCase(),
                }
          }
          eventOrShiftTab={
            pendingDragUpdate.isBusySlot
              ? false
              : pendingDragUpdate.eventData?.isShift || false
          }
          busySlots={pendingDragUpdate.isBusySlot || false}
          repeatedOptionChanged={pendingDragUpdate.anyChangedForDate || false}
          handleConfirm={async (value) => {
            setIsDragDropLoading(true);
            try {
              if (pendingDragUpdate.isBusySlot) {
                await performBusySlotUpdate(
                  pendingDragUpdate.eventData,
                  pendingDragUpdate.newDateTime,
                  value,
                  pendingDragUpdate.officeDetails,
                  pendingDragUpdate.officeIds,
                  pendingDragUpdate.busySlotEmployeeView,
                  pendingDragUpdate.isAllDayBusy,
                  pendingDragUpdate.repeatedType,
                  pendingDragUpdate.repeatedEndDate,
                  pendingDragUpdate.originalRequestedDate,
                  pendingDragUpdate.UpdateFlags,
                );
              } else {
                await performEventUpdate(
                  pendingDragUpdate.eventData,
                  pendingDragUpdate.newDateTime,
                  value,
                  pendingDragUpdate.originalRequestedDate,
                );
              }
            } catch {
            } finally {
              setEditModalConfirmation(false);
              setPendingDragUpdate(null);
              setIsDragDropLoading(false);
            }
          }}
        />
      )}
    </div>
  );
}

export default withTranslation()(MonthlyViewNew);
